module.exports = __webpack_public_path__ + "assets/img/2-2.2ab5d949.svg";